module.exports = __webpack_public_path__ + "static/img/suvidi-foot-logo-new.a635dc1b.png";